export enum GroupMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}
